<template>
<div class="user-theme" :style="{'min-height':height+'px'}">
  <div class="user-theme-item" v-for="item,index in theme_list" :key="index">
    <div class="theme-type">
      <div class="theme-type-title">
        <div>
          {{item.name}}
          <span class="theme-type-status">更新中</span>
        </div>
        <span class="theme-type-len">共<i>{{item.theme_arr.length}}</i>个专题</span>
      </div>
      <div class="theme-type-des" v-if="item.description">{{item.description}}</div>
    </div>
    <ul class="user-theme-list">
      <li v-for="item2,index2 in item.theme_arr" :key="index2" v-if="index2 < 5 || show_list[item.id].show">
        <div class="theme-img" @click="goDetail(item2.uid)">
          <img :src="item2.logo_path | logo_show" />
        </div>
        <div class="theme-info">
          <div class="theme-title" @click="goDetail(item2.uid)">{{item2.title}}</div>
          <div class="theme-dec">
            <span>{{item2.latest_content[0].publish_time | time_standard}}更新</span>
            <span>{{item2.latest_content[0].title}}</span>
          </div>
          <a @click="goDetail(item2.uid)" class="btn">阅读</a>
        </div>
      </li>
    </ul>
    <div class="list-bottom" v-if="show_list[item.id].length > 5">
      <button class="more-btn" @click="handleMore(item.id)">
        <template v-if="!show_list[item.id].show">查看更多</template>
        <template v-else>收起更多</template>
      </button>
    </div>
  </div>
  <Nothing v-if="total == 0">
    <p>暂无购买的专题</p>
  </Nothing>
  <Spin fix v-if="loading">
    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
    <div>Loading</div>
  </Spin>
</div>
</template>
<script>
import {
  paidThemeType
} from '../../../service'
import Nothing from '@/components/Nothing2'
export default {
  components: {
    Nothing
  },
  props: ['meta'],
  data() {
    return {
      theme_list: [],
      total: 0,
      height: 0,
      params: {
        page: 1
      },
      show_list: {},
      loading: true
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  methods: {
    async paidThemeType() {
      let res = await paidThemeType({
        user_key: this.$store.state.user_key
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'theme_list', res.res)
        this.$set(this.$data, 'total', res.count)
        res.res.map((a) => {
          this.show_list[a.id] = {
            show: false,
            length: a.theme_arr.length
          }
        })
        this.loading = false
        this.$forceUpdate()
        this.$emit('themeTotal', res.count)
      } else {
        this.loading = false
        this.$Message.error(res.message)
      }
    },
    goDetail(uid) {
      const { href } = this.$router.resolve({ name: "SpecialDetail", params: { uid: uid } })
      window.open(href, '_blank')
    },
    handleMore(item_id) {
      this.show_list[item_id].show = !this.show_list[item_id].show
      this.$forceUpdate()
    }
  },
  created() {
    this.paidThemeType()
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 202
    // window.onresize = () => {
    //   this.height = document.documentElement.clientHeight - 242
    // }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.user-theme
  position: relative
  .theme-type
    &-title
      justify-content: flex-end
      display: flex
      font-size: 16px
      font-weight: 500
      commonColor(rgba(233,233,235,1), #333333)
      > div
        flex: 1
      .theme-type-status
        inlineBlock()
        font-size: 12px
        width: 52px
        height: 16px
        background: #fa7a50
        border-radius: 8px
        text-align: center
        line-height: 16px
        margin-left: 6px
        color: #fff
      .theme-type-len
        i
          font-style: normal
          color: #fa7a50
    &-des
      font-size: 14px
      font-weight: 500
      commonColor(#bcbdc1, #666666)
      margin-top: 12px
      line-height: 20px
      margin-bottom: -4px
  &-item
    padding: 20px 30px
    &+div
      padding-top: 10px
  &-list
    commonBgColor(#1F2330, #FFFFFF)
    li
      padding: 20px 0
      display: flex
      &+li
        border-top: 1px solid
        commonBorderColor(#40444F, #F3F3F3)
      .theme
        &-img
          position: relative
          flex: 0 0 100px
          height: 62px
          overflow: hidden
          cursor: pointer
          img
            width: 100%
            height: 100%
        &-info
          margin-left: 16px
          position: relative
          flex: auto
          padding-right: 100px
          .btn
            position: absolute
            width: 70px
            height: 30px
            border-radius: 15px
            border: 1px solid #fa7a50
            font-size: 12px
            font-weight: 400
            color: #fa7a50
            line-height: 28px
            text-align: center
            right: 0
            top: 50%
            margin-top: -15px
            transition_02s()
            &:hover
              background: #fa7a50
              color: #fff
        &-title
          font-size: 14px
          font-weight: 500
          commonColor(rgba(233,233,235,1), #333333)
          line-height: 20px
          max-height: 40px
          display: -webkit-box
          overflow: hidden
          text-overflow: ellipsis
          word-break: break-all
          -webkit-box-orient: vertical
          -webkit-line-clamp: 2
          cursor: pointer
          &:hover
            color: #fa7a50
        &-dec
          position: absolute
          bottom: 0
          width: 100%
          padding-right: 100px
          font-size: 12px
          line-height: 18px
          height: 18px
          commonColor(#BCBDC1, #999999)
          span:first-of-type
            color: rgba(250, 122, 80, 1)
            margin-right: 21px
            position: relative
            &:before
              position: absolute
              content: ''
              height: 11px
              width: 1px
              commonBgColor(#40444F, #E9E9E9)
              right: -11px
              top: 1px
.list-bottom
  text-align: center
  position: relative
  .more-btn
    border: 1px solid rgba(250, 122, 80, 1)
    border-radius: 18px
    display: inline-block
    width: 108px
    height: 36px
    background: transparent
    color: rgba(250, 122, 80, 1)
    cursor: pointer
    &:hover
      color: #FC9C7C
      border-color: #FC9C7C
</style>
